export const COMPANY_NAME = 'Anti-Byte';
